import React, { useState } from "react";
import styled from "styled-components";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official'
import DefaultLineTable from "../avalia/DefaultLineTable";

const SerialLineChart = ({ tipo, titulo, tituloCompleto, dados, escala }) => {

    var options = {
        chart: {
            height: 600,
            // type: 'line',
            type: 'bar',
            // backgroundColor: "transparent" , //deixa o fundo transparente
            // plotBackgroundColor: null,
            events: {
                load: function (event) {
                    this.series.forEach(function (d, i) { if (d.options.id == 1) d.hide() })
                }
            }
        },
        title: {
            text: tituloCompleto ? `${tituloCompleto && tituloCompleto}` : ''
        },
        xAxis: {
            categories: escala,
            labels: {
                rotation: 0,
                style: {
                    fontSize: '13px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: `Proficiência`
            }
        },
        // colors:['#fff','#cccc'],
        legend: {
            enabled: true,
            layout: 'horizontal',
            borderWidth: 0,
            symbolHeight: 10,
            symbolWidth: 16,
            symbolRadius: 8,
            itemMarginTop: 10,
            maxHeight: 100

        },
        tooltip: {
            formatter: function () {
                return '<b>' + this.series.name + ': ' + this.point.name + '</b><br/>' +
                    'Proficiência média: ' + Highcharts.numberFormat(this.y, 2);
            }
        },
        series: dados && dados


    }
    return (
        <div
            style={{
                width: '97.5%',
                borderRadius: '8px',
                padding: '1rem',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
            <div>
                <DefaultLineTable dados={dados} titulo={titulo} />
            </div>
        </div>
    );
}


export default styled(SerialLineChart)`
display:flex;
width:100%;
height:100%;
background-color: #3e2;
.div {
    color: #3e2;
}
`
